import React from "react";
import {
  Box,
  Button,
  Chip,
  Collapse,
  Divider,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { formatAmount } from "../../../../../utils/hooks/dataHandler";

const InvestmentIncomeDetails = ({
  incomeRows = [],
  baseLabel,
  baseAmount,
  cappedRate,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!incomeRows.length) {
    return null;
  }

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1.5,
        p: 2,
        bgcolor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant='caption' color='text.secondary'>
            Total Income Details
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Typography
              variant='subtitle1'
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              {formatAmount(baseAmount)}
            </Typography>
            <Chip
              size='small'
              label={`${cappedRate}% cap`}
              variant='outlined'
              sx={{ textTransform: "none" }}
            />
          </Box>
          <Typography variant='caption' color='text.secondary'>
            Derived from {baseLabel}
          </Typography>
        </Box>
        <Button
          size='small'
          onClick={() => setExpanded((prev) => !prev)}
          endIcon={
            expanded ? (
              <ExpandLessIcon fontSize='small' />
            ) : (
              <ExpandMoreIcon fontSize='small' />
            )
          }
        >
          {expanded ? "Hide income breakdown" : "View income breakdown"}
        </Button>
      </Box>
      <Collapse in={expanded} timeout='auto' unmountOnExit>
        <Divider sx={{ my: 1.5 }} />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            rowGap: 1,
            columnGap: 2,
          }}
        >
          {incomeRows.map((row) => (
            <React.Fragment key={row.rowId}>
              <Typography sx={{ fontWeight: 500 }}>
                {row.description || "Untitled item"}
              </Typography>
              <Typography sx={{ fontWeight: 500 }} textAlign='right'>
                {formatAmount(row.amount)}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default InvestmentIncomeDetails;
